module.exports = __webpack_public_path__ + "img/section2.e36345a4.png";